import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

import { Button } from "./components/button/button.theme";
import { Card } from "./components/card/card.theme";
import { Heading } from "./components/heading/heading.theme";
import { Text } from "./components/text/text.theme";
import { Link } from "./components/link/link.theme";
import { Menu } from "./components/menu/menu.theme";
import { Accordion } from "./components/accordion/accordion.theme";

import * as colors from "./foundations/colors.theme";
import * as font from "./foundations/font.theme";
import * as breakpoints from "./foundations/breakpoints.theme";
import * as styles from "./foundations/global.theme";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
}

export const theme = extendTheme({
  config,
  ...colors,
  ...font,
  ...breakpoints,
  ...styles,
  components: {
    Accordion,
    Button,
    Card,
    Heading,
    Link,
    Text,
    Menu,
  }
});
